module.exports = __webpack_public_path__ + "media/flags/qa-9d96db36.svg";